/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import { injectIntl, intlShape } from "react-intl";
import { Grid, Row, Col } from "react-bootstrap";
import Nvl from "loracoms/Nvl";
// import PageLoading from 'loracoms/PageLoading';
import gatewayActions from "loraactions/gateway";
import Toolbar from "loracoms/Toolbar";
import IntlMsg from "lorautils/intl/IntlMsg";
import callAPI from "@/api/callAPI";
import Status from "./Status";
import Channels from "./Channels";
import Pies from "./Pies";
import styles from "./styles.scss";

const propTypes = {
  intl: intlShape.isRequired,
  id: React.PropTypes.string.isRequired,
  getGateway: PropTypes.func.isRequired,
  // pushState: React.PropTypes.func.isRequired,
  replaceState: React.PropTypes.func.isRequired,
  gatewayDetail: PropTypes.object.isRequired,
};

class GatewayStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "",
      gatewayStatus: {},
      gatewayDetail: props.gatewayDetail,
    };
    this.intlMsg = new IntlMsg(props.intl, "network.tdm.detailview");
  }

  componentDidMount() {
    const { id, getGateway } = this.props;
    getGateway(id);
    this.loadStatus();
  }

  componentWillReceiveProps({ gatewayDetail }) {
    if (!_.isEqual(gatewayDetail, this.props.gatewayDetail)) {
      this.setState({ gatewayDetail });
    }
  }

  loadStatus() {
    this.setState({ status: "pending" });
    callAPI({
      endpoint: `/tdmng/gateways/${this.props.id}/status`,
    })
      .then((res) => {
        this.setState({ status: "success", gatewayStatus: res });
      })
      .catch(() => {});
  }

  renderToolbar() {
    const { replaceState } = this.props;
    const {
      gatewayDetail: { status, data = {} },
    } = this.state;

    // '/network/tdm'
    const breadcrumb = [
      {
        onClick: () => replaceState("/network/tdm"),
        content: this.intlMsg.msg("toolbar.firstnav"),
      },
      {
        content: <Nvl val={data.name} status={status} />,
        active: true,
      },
    ];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  render() {
    const { status, gatewayStatus } = this.state;
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>{this.renderToolbar()}</Col>
        </Row>
        <Row className={styles.row}>
          <Col md={8}>
            <Channels gatewayStatus={gatewayStatus} status={status} />
            <Pies gatewayStatus={gatewayStatus} status={status} />
          </Col>
          <Col md={4}>
            <Status
              gatewayStatus={gatewayStatus}
              status={status}
              id={this.props.id}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

GatewayStatus.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  id: ownProps.params.id,
  gatewayDetail: state.gateway.gateway,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  replaceState: routerActions.replace,
  getGateway: gatewayActions.gateway,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(GatewayStatus));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/GatewayStatus/index.jsx